import React from 'react';
import { clsx } from 'clsx';
import { useMediaQuery } from 'react-responsive';

import { Header } from './Header';
import { Sidebar } from './Sidebar';

import styles from './styles.module.scss';
import { Navbar } from './Navbar';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const isLargeDevice = useMediaQuery({
    query: '(min-width: 1050px)'
  });

  return (
    <div className={styles.body}>
      {
        isLargeDevice ? (
          <div className='d-flex flex-fill wrapper'>
            <Sidebar />
            <main className='d-flex flex-column flex-grow-1'>
              <Header />
              {children}
              <div className='d-flex flex-column align-items-center justify-content-center' style={{ marginTop: '30px', marginBottom: '15px', fontWeight: 300, color: 'white' }}>
                <div>
                  OneDex Disclaimer
                </div>

                <div>
                  Being the first permissionless DEX on MultiversX comes with multiple benefits for our users, but where there are benefits, there are also risks.
                </div>

                <div>
                  Anyone can list a project, make sure you have DYOR before purchasing!
                </div>
              </div>
            </main>
          </div>
        )
        : (
          <div className='d-flex flex-column'>
            <Header />
            <main className='d-flex flex-column flex-grow-1'>
              {children}
            </main>
            <Navbar />
          </div>
        )
      }
    </div>
  );
};
